import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PrivacyPolicyContent from '../components/PrivacyPolicyContent';
import ContactPopup from '../components/ContactPopup';

const PrivacyPolicy = () => {
  // Popup state management
  const [popupState, setPopupState] = useState({
    isOpen: false,
    title: "Get in Touch",
    subtitle: "Connect with our admissions team to learn more about our programs",
    formType: "popup_inquiry",
    interestedProgram: ""
  });

  const openPopup = (config: {
    title?: string;
    subtitle?: string;
    formType?: string;
    interestedProgram?: string;
  } = {}) => {
    setPopupState({
      isOpen: true,
      title: config.title || "Get in Touch",
      subtitle: config.subtitle || "Connect with our admissions team to learn more about our programs",
      formType: config.formType || "popup_inquiry",
      interestedProgram: config.interestedProgram || ""
    });
  };

  const closePopup = () => {
    setPopupState(prev => ({ ...prev, isOpen: false }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header openPopup={openPopup} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy and Disclaimer</h1>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-lg mb-8">
            <p className="text-gray-700 leading-relaxed">
              <strong>Business identity:</strong> 1to10x is a public-facing brand name used for programs and services offered through this website. ANM ENABLERS PRIVATE LIMITED and 1to10X LLC provide such programs and services, as applicable, for their respective operations and obligations.
            </p>
          </div>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. INTRODUCTION</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              ANM ENABLERS PRIVATE LIMITED and 1to10X LLC, operating under the 1to10x brand for their respective operations (hereinafter "1to10X," "us," "we," "our," or "the Company"), are committed to the security and management of personal data of individuals (Personal Data), to function effectively and successfully for the benefit of our stakeholders, vendors, customers and for the community. In doing so, it is essential that people's privacy is protected through the lawful and appropriate means for handling Personal Data. Therefore, we have implemented this Privacy Policy (hereinafter referred to as ''Policy'').
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. AIM</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              This Policy aims to protect Personal Data of the various stakeholders connected to our organization. This Policy is aimed at providing individuals notice of the basic principles by which the company processes Personal Data who visits, uses, deals with and/or transacts through the website and includes a guest user and browser (hereinafter 'you', 'user').
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. PURPOSE AND SCOPE</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The purpose of this Policy is to describe how 1to10X collects, uses, and shares information about you through our online interfaces (e.g., websites) owned and controlled by us, including but not limited to https://www.1to10X.com/ and https://www.10xDataAnalyst.com (hereinafter individually or collectively referred to "website"). This Policy is also designed to provide information on how 1to10X ensures data security, conducts data transfers and process requests from data subjects.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              This Policy control applies to all systems, people and processes that constitute the company's information systems, including board members, directors, employees and other third parties who have access to Personal Data available within 1to10X.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              The company is also committed to ensure that its employees conduct themselves in line with this, and other related, policies. Where third parties process Personal Data on behalf of 1to10X, the company endeavors to obtain assurances from such third parties that your Personal Data will be safeguarded consistently.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              1to10X offers curated and specially designed industry-relevant certificate and bootcamp programs online ("hereinafter individually or collectively referred to as Program"). This Policy applies to all our services unless specified otherwise.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. TYPES OF PERSONAL DATA COLLECTED</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The Personal Data that we collect about you depends on the context of your interactions with us, the products, services and features that you use, your location, and the applicable laws.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Personal Data is stored in personnel files or within the electronic records (on servers in United States or other countries) of 1to10X. The following types of Personal Data may be held by 1to10X, as appropriate, on relevant individuals:
            </p>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">A. Personal Identification Data</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>First Name, Last name</li>
                  <li>Professional title & Company</li>
                  <li>Signature</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">B. Financial Data (Only of our Creditors)</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Bank Account information</li>
                  <li>Compensation Information</li>
                  <li>Payment gateway account details</li>
                  <li>E-wallet account details</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">C. Personal Characteristics</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Age</li>
                  <li>Gender</li>
                  <li>Date of Birth</li>
                  <li>Marital Status</li>
                  <li>Nationality</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">D. Contact Data</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Postal address</li>
                  <li>Email address</li>
                  <li>Phone number</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">E. Education and Recruitment Data</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Educational qualification(s)</li>
                  <li>Working goals</li>
                  <li>Post-qualification experience</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">F. Electronic Identification Data</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Account login details (if you are a registered user)</li>
                  <li>Visitors IP Data</li>
                  <li>Date and time of website visit</li>
                  <li>Pages visited and navigation on the website</li>
                  <li>Browser being used</li>
                  <li>County of accessing website</li>
                  <li>Language of the browser being used</li>
                  <li>Words searched for</li>
                  <li>Pixel tags</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">G. Inquiries</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Personal Data stated in the form – for example: Name, address, phone number, country</li>
                  <li>Subject of Inquiry</li>
                  <li>Personal details (Name on the card, billing address)</li>
                  <li>Payment details (card numbers, card type)</li>
                  <li>Recordings of calls with students and users showing interest in our Program</li>
                  <li>Information about your interactions with customer service and maintenance interactions with us</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">H. User Generated Data</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Projects and Assignments submitted</li>
                  <li>Peer feedback and grading</li>
                  <li>Program performance data</li>
                  <li>Response to quizzes, standalone quizzes, exams, and surveys</li>
                  <li>Web Cam Recordings (during assessments related to online courses)</li>
                  <li>Posts made to public forums through our platform</li>
                  <li>Any other information necessary to ensure conformity with test/ assessment rules, area of interests</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">I. Marketing Data</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Your preferences in receiving marketing information from us</li>
                  <li>Your communication preferences</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">J. Behavioural Data</h3>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Data inferred or assumed information relating to your behavior and interests based on your online activity on our sites</li>
                </ul>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed mt-4">
              We do not collect any payment information processed by third-party payment gateway providers.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. SOURCES OF DATA COLLECTION</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The Personal Data collected by 1to10X is derived directly from the data provided by the user or by use of our sites.
            </p>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Data Collected when You:</h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                  <li>Register for seminars, webinars or other outreach initiatives made available by us</li>
                  <li>Request a quote for the various products and services offered by us</li>
                  <li>Place a feedback, complete any customer surveys circulated or interact with our customer services online</li>
                  <li>View our services or visit our website pages on the internet</li>
                  <li>Browse our website</li>
                  <li>When you appear for assignments, exams or any other assessments in relation to online course</li>
                  <li>When you avail scholarships or refunds</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Data Collected from third parties</h3>
                <p className="text-gray-700 leading-relaxed mb-2">
                  We receive Personal Data such as access or login details, profile picture or any other text / image in relation to your Personal Data which may be available with such third parties.
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  We also receive information about your visits to this platform and to other websites using pixel tags.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Third parties from whom we receive your Personal Data may include our service providers, networks connected to our service, advertising partners, marketing affiliates, scholarship support providers, analytics providers, and other third-party sources that help us operate or improve our services.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. COOKIES</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">A. 1to10X uses cookies in a range of ways to improve your experience on our website, including:</h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                  <li>To recognize our website user and to enhance user experience when interacting with our website.</li>
                  <li>We moreover use cookies to help us to analyse the use and performance of our website and services.</li>
                  <li>We also use cookies to improve the delivery and value of various services and products offered by us.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">B. What types of cookies do we use?</h3>
                <p className="text-gray-700 leading-relaxed mb-2">
                  There are a few different types of cookies, however, our website uses:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li><strong>Persistent Cookies.</strong> We use persistent Cookies to improve your experience of using the Sites. This includes recording your acceptance of our Cookie Policy to remove the cookie message which first appears when you use the Sites.</li>
                  <li><strong>Session Cookies.</strong> Session Cookies are temporary and deleted from your machine when your web browser closes. We use session Cookies to help us track internet usage as described above.</li>
                  <li><strong>Analytical/Performance Cookies.</strong> Analytical cookies allow us to recognize and count the number of visitors and see how many visitors move around our website while they are using it. This helps us improve the way our website works, for example, by ensuring the users find what they are looking for.</li>
                  <li><strong>Functionality Cookies.</strong> Functionality Cookies recognize when you return to the website. This enables the company to create greater content for you and remember your likes and dislikes and other preferences.</li>
                  <li><strong>Targeting Cookies.</strong> Targeting Cookies records the visit to our website, the pages navigated to and the links clicked upon. It helps to formulate information relevant to the user's area of interests.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">C. How to manage cookies?</h3>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary from browser to browser, and from version to version. Disabling some cookies form the website, may have a negative impact and may result in some non-availability of some features.
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  If you want to remove previously-stored Cookies, you can manually delete the Cookies at any time. However, this will not prevent the Sites from placing further Cookies on your device unless and until you adjust your Internet browser setting as described above.
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  You can however obtain up-to-date information about blocking and deleting cookies via these links:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                  <li><a href="https://support.google.com/chrome/answer/95647" className="text-blue-600 hover:text-blue-800 underline">Chrome</a></li>
                  <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" className="text-blue-600 hover:text-blue-800 underline">Firefox</a></li>
                  <li><a href="https://www.opera.com/help/tutorials/security/cookies/" className="text-blue-600 hover:text-blue-800 underline">Opera</a></li>
                  <li><a href="https://support.apple.com/kb/PH21411" className="text-blue-600 hover:text-blue-800 underline">Safari</a></li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-2">
                  These opt-out mechanisms rely on cookies to remember your choices. If you delete your cookies, use another computer or device, or change browsers, you will need to repeat this process. In addition, opting out of interest-based ads will not opt you out of all ads, but rather only those ads that are personalized to your interests.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. DATA ANALYTICS</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We use Analytics tools and search information providers to measure how visitors interact with content on our website. We also use Facebook Custom Audiences to ask Facebook to show you ads that are customized based on your interaction with our websites or our Facebook applications and to measure how you interact with those ads. Additional information on how these services use such technologies can be found on Google's website, and Facebook's website.
            </p>
            <p className="text-gray-700 leading-relaxed">
              If you do not wish to have data relating to your visits to our websites collected through Google Analytics, you may opt-out by installing the Google Analytics opt-out browser add-on. You may opt-out of Facebook Custom Audiences by visiting Facebook's opt-out page.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. AGGREGATED DATA</h2>
            <p className="text-gray-700 leading-relaxed">
              "Aggregated Data" means records that have been stripped of Personal Data and has been combined to provide generalised, anonymous information. Your identity and personal information are not available in Aggregated Data. We combine your Personal Data on an anonymous basis with other information to generate Aggregated Data for internal and commercial use and for sharing with affiliates, subsidiaries and business partners for planning and marketing purposes.
            </p>
          </section>

          <PrivacyPolicyContent />
        </div>
      </div>
      <Footer />
      
      <ContactPopup
        isOpen={popupState.isOpen}
        onClose={closePopup}
        title={popupState.title}
        subtitle={popupState.subtitle}
        formType={popupState.formType}
        interestedProgram={popupState.interestedProgram}
      />
    </div>
  );
};

export default PrivacyPolicy; 
